@if (device) {
  <div class="client-device" [pTooltip]="device.description" tooltipPosition="top">
    <div class="client-device__name">
      <i [class]="icon" aria-hidden="true"></i>
      <span>{{ name }}</span>
    </div>
    <div class="client-device__details">
      @if (system) {
        <span>{{ system }}</span>
      }
      @if (app) {
        <span class="client-device__app">app {{ app }}</span>
      }
      @if (screen) {
        <span [pTooltip]="screenTooltip" tooltipPosition="bottom"><i class="pi pi-mobile" aria-hidden="true"></i> {{ screen }}</span>
      }
    </div>
  </div>
} @else {
  <span class="client-device__unknown">—</span>
}
